export default "__VITE_ASSET__ztKDLHDg__"